





































































































import Vue from "vue";
import Component from "vue-class-component";

import Btn from "../../../../shared/Btn.vue";
import StringField from "../../../../shared/fields/StringField.vue";
import ListeStrings from "../../../../shared/fields/ListeStrings.vue";
import { ConclusionInscription } from "../types";
import { ValidEvent } from "../../../../shared/utils";
import { isEmailValid } from "../../../../shared/logic/utils";

const TabConcluProps = Vue.extend({
  props: {
    conclusion: Object as () => ConclusionInscription | null
  },
  model: {
    prop: "conclusion",
    event: "change"
  }
});
@Component({
  components: { Btn, StringField, ListeStrings }
})
export default class TabConclu extends TabConcluProps {
  validated = false;

  mailValidator = isEmailValid;

  onValid(ev: ValidEvent) {
    this.$emit("valid", ev);
  }
}
